import React from 'react'
import PropTypes from 'prop-types'

import Styles from './index.scss'

const SendButtonActive = props => (
  <button
    className={Styles['btn-send-active']}
    onClick={props.resendEmail(props.email)}
  >
    re-send email verification
  </button>
)

SendButtonActive.propTypes = {
  resendEmail: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
}

export default SendButtonActive
